<template>
    <button class="btn btn-primary" :class="btnClass" :disabled="poster.submitted" @click="posterPost()">
        <span class="spinner-border spinner-border-sm"></span>
        <slot></slot>
    </button>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        employee: {
            required: true
        },
        btnClass: {
            default: ''
        }
    },

    computed: {
        posterUrl () {
            return '/employees/' + this.employee.id + '/sendAppUrl'
        }
    },

    methods: {
        posterSuccess (data) {
            bus.$emit(
                'notify',
                'Notis med länk till webappen har skickats.'
            )
            this.$emit('success')
        }
    }
}
</script>
